import React from 'react';
import ReactDOM from 'react-dom/client';
import { App } from './App';
import '@oolio-group/design-ui-react/global.css';
import '@oolio-group/design-ui-react/components.css';

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
